import { v4 as uuidv4 } from "uuid";

export const useGenerateUID = (): string => {
  return uuidv4();
};
